import React from 'react';
import PropTypes from 'prop-types';

/**
 * CardHeader - A wrapper that renders a standard HTML header element with Bulma card-header class names
 * 
 * This component accepts the same props as Bloomer CardHeader for easy migration
 */
const CardHeader = ({
  className,
  style,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['card-header'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <header 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </header>
  );
};

CardHeader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

CardHeader.defaultProps = {
  className: '',
  style: {},
  children: null
};

export default CardHeader;
